<div class="markdown-container">
  <remark
    [markdown]="markdown"
    [processor]="processor">
    <ng-template remarkTemplate="code" let-node>
      <div class="code-block">
        <pre><code [highlight]="node.value" [language]="node.lang || 'plaintext'"></code></pre>
      </div>
    </ng-template>
  </remark>
</div>
